import { gql } from "lib/apolloClient";
import {
  plannerElementSetFieldsFragment,
  downloadUrlResponseFragment,
} from "./PlannerElementSetConfigurationFragments";
import { attachmentFragment } from "modules/CommonFragments";

export const getGlobalPlannerElementSetPropertiesQuery = gql`
  query getGlobalPlannerElementSetProperties(
    $uiType: PLANNER_ELEMENT_TYPE_ENUM
  ) {
    planner {
      globalPlannerElementSetConfig(uiType: $uiType) {
        id
        config
        valueType
      }
    }
  }
`;

export const getPlannerElementSetsQuery = gql`
  query getPlannerElementSetsQuery(
    $id: ID!
    $curriculumNodeInterfaceType: ENTITY_TYPE_ENUM!
    $category: [PLANNER_ELEMENT_SET_CATEGORY_ENUM!]
    $templateFieldFilters: PlannerElementTemplateFieldFilters
    $templateFilters: PlannerElementTemplateFilters
    $templateFieldConfigFilters: TemplateFieldConfigFilter
    $templateFieldPropertyValuesFilters: TemplateFieldPropertyValuesFilter
  ) {
    node(id: $id, type: $curriculumNodeInterfaceType) {
      id
      ... on IbPypCurriculumProgram {
        plannerElementSets(category: $category) {
          ...PlannerElementSetFields
        }
      }
      ... on IbDpCurriculumProgram {
        plannerElementSets(category: $category) {
          ...PlannerElementSetFields
        }
      }
      ... on IbMypCurriculumProgram {
        plannerElementSets(category: $category) {
          ...PlannerElementSetFields
        }
      }
      ... on UBDCurriculumProgram {
        plannerElementSets(category: $category) {
          ...PlannerElementSetFields
        }
      }
    }
  }
  ${plannerElementSetFieldsFragment}
`;

export const getPlannerElementSetDownloadUrlQuery = gql`
  query getPlannerElementSetDownloadUrl(
    $curriculumProgramId: ID!
    $curriculumNodeInterfaceType: ENTITY_TYPE_ENUM!
    $input: DownloadPlannerElementSetDataInput
  ) {
    node(id: $curriculumProgramId, type: $curriculumNodeInterfaceType) {
      id
      ... on IbPypCurriculumProgram {
        downloadPlannerElementSetData(input: $input) {
          ...downloadUrlResponseItem
        }
      }
      ... on IbDpCurriculumProgram {
        downloadPlannerElementSetData(input: $input) {
          ...downloadUrlResponseItem
        }
      }
      ... on IbMypCurriculumProgram {
        downloadPlannerElementSetData(input: $input) {
          ...downloadUrlResponseItem
        }
      }
      ... on UBDCurriculumProgram {
        downloadPlannerElementSetData(input: $input) {
          ...downloadUrlResponseItem
        }
      }
    }
  }
  ${downloadUrlResponseFragment}
`;

export const getCardPlannerElementSetDetailsQuery = gql`
  query getCardPlannerElementSetDetails($id: ID!) {
    node(id: $id, type: PLANNER_ELEMENT_SET) {
      id
      ... on PlannerElementSet {
        id
        label
        type
        config {
          id
          config
          valueType
          value
        }
        nodes {
          id
          label
          subText
          displaySequence
          type
          depth
          icon {
            ...attachmentBasicDetailsItem
          }
        }
      }
    }
  }
  ${attachmentFragment.basicDetails}
`;

export const getChecklistPlannerElementSetDetailsQuery = gql`
  query getChecklistPlannerElementSetDetails($id: ID!) {
    node(id: $id, type: PLANNER_ELEMENT_SET) {
      id
      ... on PlannerElementSet {
        id
        label
        type
        nodes {
          id
          label
          displaySequence
          type
          depth
        }
      }
    }
  }
`;

export const getNestedChecklistPlannerElementSetDetailsQuery = gql`
  query getNestedChecklistPlannerElementSetDetails($id: ID!) {
    node(id: $id, type: PLANNER_ELEMENT_SET) {
      id
      ... on PlannerElementSet {
        id
        label
        type
        nodes {
          id
          label
          displaySequence
          type
          depth
          code
          parentId: parent
          children
          associatedParents {
            id
            ... on Grade {
              id
              name
            }
          }
          tags: genericTags {
            id
          }
        }
      }
    }
  }
`;

export const getCurriculumProgramGradeBasicDetailsQuery = gql`
  query getCurriculumProgramGradeBasicDetails(
    $organizationId: ID!
    $filters: GradeFilterInput
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        grades(filters: $filters) {
          id
          name
          displaySequence
          curriculumProgram {
            id
          }
        }
      }
    }
  }
`;

export const getPlannerElementSetConfigQuery = gql`
  query getPlannerElementSetConfigQuery($id: ID!) {
    node(id: $id, type: PLANNER_ELEMENT_SET) {
      id
      ... on PlannerElementSet {
        config {
          id
          config
          valueType
          value
        }
      }
    }
  }
`;

export const getPlannerElementSetQuery = gql`
  query getPlannerElementSetQuery($id: ID!) {
    node(id: $id, type: PLANNER_ELEMENT_SET) {
      id
      ... on PlannerElementSet {
        type
        config {
          id
          config
          valueType
          value
        }
      }
    }
  }
`;
